import cx from 'classnames';
import { memo } from 'react';
import Spinner from '@wg/wows-react-uikit/components/Spinner/Spinner';

import { useAppSelector } from '~/store';
import { applicationsIsFetchingJoinClanSelector } from '~/store/selectors/applicationsSelectors';
import { clanRenameIsProcessingSelector } from '~/store/selectors/clanRenameSelectors';
import { currentAccountSelector } from '~/store/selectors/currentAccountSelector';

import styles from './ClanHeader.module.scss';
import ClanHeaderActions from './ClanHeaderActions';
import ClanHeaderLeagueSign from './ClanHeaderLeagueSign';
import ClanHeaderTitle from './ClanHeaderTitle';

import type { ClanInfoType } from '~/Actions/ActionClanProfile';
import type { ClanPreloaded } from '~/types/declaration';

interface ClanHeaderProps {
  clan: ClanInfoType | ClanPreloaded;
  isOwnClanBase: boolean;
  className?: string;
}

const ClanHeader = ({ clan, isOwnClanBase, className }: ClanHeaderProps) => {
  const currentAccount = useAppSelector(currentAccountSelector);
  const isFetchingJoinClan = useAppSelector(applicationsIsFetchingJoinClanSelector);
  const isRenameInProcess = useAppSelector(clanRenameIsProcessingSelector);

  return (
    <div className={cx(styles.container, className)}>
      <ClanHeaderLeagueSign clanId={clan.id} isOwnClanBase={isOwnClanBase} />
      <div>
        <ClanHeaderTitle
          clan={clan}
          currentAccount={currentAccount}
          isRenameInProcess={isRenameInProcess}
          isOwnClanBase={isOwnClanBase}
        />
        <div
          className={cx(styles.clanActions, {
            [styles.clanActionsOwn]: isOwnClanBase,
          })}
        >
          {isFetchingJoinClan ? (
            <Spinner />
          ) : (
            <ClanHeaderActions clan={clan} currentAccount={currentAccount} isOwnClanBase={isOwnClanBase} />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(ClanHeader);
